import {Component} from "react";
import Layout from "../components/Layout";
import React from "react";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import {connect} from "react-redux";
import Table from "@material-ui/core/Table";
import LoadingScreen from "../components/LoadingScreen";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import TableCell from "@material-ui/core/TableCell";
import EventRow from "../components/EventRow";
import {fetchEvents} from "../actions/eventsActions";
import Dialog from "@material-ui/core/Dialog";
import AddEventModal from "../components/modals/AddEventModal";

const styles = {
    paper: {
        width: '1',
    },
};

class Events extends Component {

    constructor(props){
        super(props);

        this.state = {open: false}
    }

    componentDidMount() {
        this.props.dispatch(fetchEvents());
    }

    render(){
        if(this.props.events.isFetching){
            return (
                <Layout>
                    <LoadingScreen reason={"Načítám akce..."}/>
                </Layout>
                )
        }
        return (
            <Layout>
                <Paper className={this.props.classes.paper}>
                    <Table>
                        {this.props.events.data.map(event => {
                            return (
                                <EventRow event={event} />
                            );
                            }
                        )}
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell align="right">
                                <Button variant="contained" size="small" color="primary" onClick={e => this.createEvent(e)}>
                                    Přidat
                                </Button>
                            </TableCell>
                        </TableRow>
                    </Table>
                    <Dialog open={this.state.open} onClose={this.handleClose}>
                        <AddEventModal handleClose={this.handleClose}/>
                    </Dialog>
                </Paper>
            </Layout>
        );
    }

    createEvent = (e) => {
        e.preventDefault();

        this.setState({open: true});
    };

    handleClose = () => {
        this.setState({open: false});
    }

}

function mapStateToProps(state) {
    const events = state.eventList;

    return {
        events,
    }
}

export default connect(mapStateToProps)(withStyles(styles)(Events))